var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditInputReference(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8062 0.528816C12.303 0.0320614 13.1084 0.0320614 13.6051 0.528816C14.1019 1.02557 14.1019 1.83097 13.6051 2.32772L6.40134 9.53152C6.04268 9.89018 5.60031 10.1538 5.1142 10.2986L3.73564 10.7093C3.54525 10.766 3.36796 10.5887 3.42467 10.3983L3.83532 9.01976C3.98012 8.53365 4.24377 8.09128 4.60243 7.73262L10.6614 1.67363L11.8062 0.528816ZM2.05859 3.58737C2.05859 3.10123 2.45269 2.70714 2.93882 2.70714H6.38042C6.79464 2.70714 7.13042 2.37136 7.13042 1.95714C7.13042 1.54293 6.79464 1.20714 6.38042 1.20714H2.93882C1.62426 1.20714 0.558594 2.27281 0.558594 3.58737V11.1951C0.558594 12.5097 1.62426 13.5753 2.93882 13.5753H10.5466C11.8611 13.5753 12.9268 12.5097 12.9268 11.1951V7.75352C12.9268 7.33931 12.591 7.00352 12.1768 7.00352C11.7626 7.00352 11.4268 7.33931 11.4268 7.75352V11.1951C11.4268 11.6813 11.0327 12.0753 10.5466 12.0753H2.93882C2.45269 12.0753 2.05859 11.6813 2.05859 11.1951V3.58737Z",
    fill: "#677B99"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditInputReference);
export default __webpack_public_path__ + "static/media/edit-input-reference.79008edcbc5ce914ece29a75af8754a0.svg";
export { ForwardRef as ReactComponent };